import {
  formatNumber,
  remove886,
  roundPrecision,
  toSegmentedPhoneNumber,
} from '../../libs/utils'

export type ConfirmPurchaseTopAreaProps = {
  phone: string
  amount: number
  amountUSD: number
}

export default function ConfirmPurchaseTopArea(
  props: ConfirmPurchaseTopAreaProps,
) {
  const { phone } = props
  return (
    <div className="container mt-navbarSpacing">
      <p className="babu-text pt-l">{`你登入的帳號是 ${toSegmentedPhoneNumber(
        remove886(phone) || phone,
      )}`}</p>
      <h2 className="babu-text-subtitle mt-xxs mb-l">確認訂單金額後付款</h2>
      <div className="my-l border-l-4 border-primary pl-m">
        <h5 className="babu-text-paragraph-bold">訂單金額</h5>
        <h1 className="babu-text-title-bold mt-m">{`NT$${formatNumber(
          props.amount,
        )}`}</h1>
        <p className="babu-text text-text500 mt-xxs">{`約等於 US$${formatNumber(
          roundPrecision(props.amountUSD),
        )}`}</p>
      </div>
    </div>
  )
}
